import React from 'react';
import ReactDOM from 'react-dom';
import App from './components/App';
import packageJson from '../package.json';

ReactDOM.render(
    <App version={packageJson.version} />,
    document.getElementById('root')
);
